import { FunctionalityService } from "../../api/functionality-service";
import Result from "../../model/result";

const state = {
};

const getters = {};

const actions = {
    async GetPersonPeriodWork(state, { params }) {
        var perno = state.rootState.auth.auth.username;
        params.append('perno', perno);

        return await FunctionalityService.GetPersonPeriodWork(params).then((response) => {
            var data = response.data
            if (data.ResponseResultType === 1) {
                return Result.success(data.Values)
            } else {
                return Result.error(data.Message)
            }
        })
    },
    async GetPersonPeriodWorkDetail(state, { params }) {
        var perno = state.rootState.personel.personelDetail.Perno;
        if (!params.get('perno')) {
            params.append('perno', perno);
        }

        return await FunctionalityService.GetPersonPeriodWorkDetail(params).then((response) => {
            var data = response.data
            if (data.ResponseResultType === 1) {
                return Result.success(data.Values)
            } else {
                return Result.error(data.Message)
            }
        })
    },
    async GetEosPeriodicYearsList() {
        return await FunctionalityService.GetEosPeriodicYearsList().then((response) => {
            var data = response.data
            if (data.ResponseResultType === 1) {
                return Result.success(data.Values)
            } else {
                return Result.error(data.Message)
            }
        })
    },
    async GetEosPeriodList(state, { params }) {
        return await FunctionalityService.GetEosPeriodList(params).then((response) => {
            var data = response.data
            if (data.ResponseResultType === 1) {
                let res = data.Values
                let list = []
                res.forEach(period => {
                    list.push(period.PERIOD)
                });
                return Result.success(list)
            } else {
                return Result.error(data.Message)
            }
        })
    },

    async getLastPeriod({ dispatch }) {
        debugger
        const params = new URLSearchParams();

        var yearsList = []
        await dispatch('GetEosPeriodicYearsList').then((result) => {
            if (result.type === "success") {
                yearsList = result.data;
            }
        })
        var year = yearsList.slice(-1)[0].Name
        params.append('year', year);

        var periodList = []
        await dispatch('GetEosPeriodList', { params }).then((result) => {
            if (result.type === "success") {
                periodList = result.data;
            }
        })

        if (periodList.length > 0) {
            var periodNumber = periodList.slice(-1)[0]
            params.append('periodNumber', periodNumber);


            return await dispatch('GetPeriodBeginAndEndDate', { params })
        } else{
            return Result.error('')
        }

    },
};

const mutations = {
};

export default {
    state,
    getters,
    actions,
    mutations
}